export default __webpack_public_path__ + "static/media/YAS0270.34I-27743_-17217_0.1d73ec0a.jpg";